// extracted by mini-css-extract-plugin
module.exports =  {"search":"mHIcMIDrZ7kdGekNFv47","placeholder":"TupO7I4VXD7GJKLLxja_"};